import { Api } from '@/interface/api';

/**
 * 获取专题页数据
 */
const sepcialGetRaceSpecials: Api = {
    url: '/api/project/proxy/api/v1/race-specials',
    method: 'get',
};

export { sepcialGetRaceSpecials };
